module.exports = __webpack_public_path__ + "img/brand-ambassador.90108cd4.png";